import React, { Component } from 'react';
import { Button }          from 'primereact/button';
import { ToggleButton }    from 'primereact/togglebutton';
import { DataTable }       from 'primereact/datatable';
import { Column }          from 'primereact/column';
import { Dialog }          from 'primereact/dialog';

import { ApiService } from 'hay-core-react';
import { UtilService } from 'hay-core-react';
import GrupoPermissao from '../../../models/GrupoPermissao';
import { withRouter } from 'hay-core-react';
import { decodificarContextoRelacao } from 'hay-core-react';
import { model as MODEL_PADRAO, renderers as RENDERERS_PADRAO, GrupoPermissaoFormulario } from './GrupoPermissaoTemplate';
import { EntityGrid } from 'hay-core-react';
import lodash from "lodash";

const ACTIONS = [
    { key: 'mostrar',    label: 'main.permissao.action.mostrar'    },
    { key: 'findOne',    label: 'main.permissao.action.visualizar' },
    { key: 'find',       label: 'main.permissao.action.listar'     },
    { key: 'create',     label: 'main.permissao.action.criar'      },
    { key: 'update',     label: 'main.permissao.action.editar'     },
    { key: 'destroy',    label: 'main.permissao.action.excluir'    },
    { key: 'auditar',    label: 'main.permissao.action.auditar'    },
    { key: 'duplicar',   label: 'main.permissao.action.duplicar'   },
];


class GrupoPermissionamentoPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            grupopermissoes:            [],
            carregando:                 true,
            salvando:                   {},
            dialogEspeciaisVisivel:     false,
            controllerEspeciaisSelecionado: null,
        };
        this.togglePermissao = this.togglePermissao.bind(this);
        this.carregar        = this.carregar.bind(this);
    }

    async carregar() {
        this.setState({ carregando: true });
        const { parentId: grupoId } = decodificarContextoRelacao(this.props.searchparams);
        const filtroGrupo = {
            grupo: { constraints: [{ value: grupoId, matchMode: 'equals' }] },
        };
        const resGP = await GrupoPermissao.list(filtroGrupo, null, { rows: 9999 }, { populate: 'permissao' });

        // EntidadeBase.list()/ApiService.get() sempre embrulham a resposta como
        // { data: { count, registros }, status } - nunca { registros, count } direto na raiz
        // (mesmo formato que EntityGrid.atualizar() consome pra grade padrão).
        this.setState({
            grupopermissoes: resGP?.data?.registros || [],
            carregando:      false,
        });
    }

    indexarGrupoPermissoes() {
        return this.state.grupopermissoes.reduce((acc, gp) => {
            const id = gp.permissao?.id ?? gp.permissao;
            if (id != null) acc[id] = gp;
            return acc;
        }, {});
    }

    getLinhas() {
        const mapa = {};
        for (const gp of this.state.grupopermissoes) {
            const p = gp.permissao;
            if (!p) continue;
            if (!mapa[p.controller]) {
                mapa[p.controller] = { controller: p.controller, nome: this.nomeController(p), acoes: {} };
            }
            mapa[p.controller].acoes[p.action] = {
                permissao: p,
                permitido: gp.permitido ?? false,
                salvando:  gp.salvando  ?? false,
            };
        }
        return Object.values(mapa).sort((a, b) => a.controller.localeCompare(b.controller));
    }

    async togglePermissao(permissao, novoValor) {
        const gp = this.indexarGrupoPermissoes()[permissao.id];
        if (!gp) return;
        const permissaoEncontrada = lodash.find(this.state.grupopermissoes, { id: gp.id });
        permissaoEncontrada.salvando = true;
        this.setState({ grupopermissoes: this.state.grupopermissoes });
        try {
            await ApiService.patch(`grupopermissao/${gp.id}`, { permitido: novoValor });
            UtilService.showToast({ severity: 'success', summary: UtilService.traduzir('main.registroAtualizado') });
        } catch {
            UtilService.showToast({ severity: 'error', summary: UtilService.traduzir('main.erroSalvar') });
        }
        permissaoEncontrada.salvando = false;
        permissaoEncontrada.permitido = novoValor;
        this.setState({ grupopermissoes: this.state.grupopermissoes });
    }

    nomeController(permissao) {
        // Não dá pra montar a chave como "main.<controller>.plural" - alguns models sobrescrevem
        // `identidade` (ex. UsuarioLog -> "main.usuariologacesso", UsuarioEquipamento ->
        // "main.usuario.equipamento"), e é sob essa identidade que a tradução realmente existe,
        // não sob o nome cru do controller. `Permissao.state` já vem montado pelo backend como
        // `${identidade}.${action}` (SetupService.js) - extraindo o sufixo da action sobra
        // exatamente a identidade certa, sem precisar duplicar esse mapeamento no frontend.
        const identidade = permissao.state.slice(0, permissao.state.length - permissao.action.length - 1);
        const chave       = identidade + '.plural';
        const traduzido   = UtilService.traduzir(chave);
        return traduzido === chave ? permissao.controller.toUpperCase() : traduzido;
    }

    renderDataTable(header) {
        const { carregando } = this.state;
        const t = (chave) => UtilService.traduzir(chave);
        const linhas = this.getLinhas();

        const actionBody = (actionKey) => (rowData) => {
            const acao = rowData.acoes[actionKey];
            if (!acao) return null;
            return (
                <ToggleButton
                    key={acao.permissao.id}
                    checked={acao.permitido}
                    disabled={acao.salvando}
                    onLabel={t('main.grupopermissao.permitido')}
                    offLabel={t('main.grupopermissao.bloqueado')}
                    onIcon="pi pi-check"
                    offIcon="pi pi-ban"
                    className={acao.permitido ? 'p-button-success' : 'p-button-danger'}
                    pt={{ icon: { style: { color: '#fff' } } }}
                    onChange={(e) => this.togglePermissao(acao.permissao, e.value)}
                />
            );
        };

        const isEspecial = (acao) => acao.permissao?.tipo !== 'main.permissao.tipo.entidade';

        const especiaisBody = (rowData) => {
            const temEspeciais = Object.values(rowData.acoes).some(isEspecial);
            return (
                <Button
                    icon="pi pi-cog"
                    text
                    severity={temEspeciais ? 'warning' : 'secondary'}
                    style={{ aspectRatio: '1 / 1' }}
                    tooltip={t('main.permissao.especiais')}
                    tooltipOptions={{ position: 'left' }}
                    onClick={() => this.setState({ dialogEspeciaisVisivel: true, controllerEspeciaisSelecionado: rowData.controller })}
                />
            );
        };

        const dialogEspeciaisHeader = (
            <div className="inline-flex align-items-center gap-2">
                <i className="pi pi-cog" />
                <span className="font-bold">{t('main.permissao.especiais.titulo')}</span>
            </div>
        );

        const dialogEspeciaisFooter = (
            <Button
                severity="info"
                label={t('main.fechar')}
                icon="pi pi-times"
                onClick={() => this.setState({ dialogEspeciaisVisivel: false, controllerEspeciaisSelecionado: null })}
                autoFocus
            />
        );

        const { dialogEspeciaisVisivel, controllerEspeciaisSelecionado } = this.state;
        const controllerAtual = linhas.find(l => l.controller === controllerEspeciaisSelecionado);
        const especiaisLinhas = controllerAtual
            ? Object.entries(controllerAtual.acoes)
                .filter(([, acao]) => isEspecial(acao))
                .map(([key, acao]) => ({ key, acao }))
            : [];

        return (
            <>
            <DataTable
                value={linhas}
                header={header}
                stripedRows
                showGridlines
                size="small"
                className="border-round-lg overflow-hidden"
                emptyMessage={carregando ? '' : t('main.semregistros')}
                loading={carregando}
                cellMemo={false}
            >
                <Column
                    field="nome"
                    header={t('main.permissao.controller')}
                    style={{ minWidth: '14rem' }}
                    bodyClassName="font-semibold"
                />
                {ACTIONS.map(a => (
                    <Column
                        key={a.key}
                        header={t(a.label)}
                        body={actionBody(a.key)}
                        style={{ width: '9rem' }}
                        headerClassName="text-center"
                        bodyClassName="text-center"
                    />
                ))}
                <Column
                    header={t('main.permissao.especiais')}
                    body={especiaisBody}
                    style={{ width: '9rem' }}
                    headerClassName="text-center"
                    bodyClassName="text-center"
                />
            </DataTable>

            <Dialog
                visible={dialogEspeciaisVisivel}
                header={dialogEspeciaisHeader}
                footer={dialogEspeciaisFooter}
                onHide={() => this.setState({ dialogEspeciaisVisivel: false, controllerEspeciaisSelecionado: null })}
                style={{ width: '32rem' }}
                modal
                draggable={false}
            >
                <DataTable
                    value={especiaisLinhas}
                    size="small"
                    stripedRows
                    showGridlines
                    emptyMessage={t('main.permissao.especiais.nenhuma')}
                    dataKey="key"
                    cellMemo={false}
                >
                    <Column
                        field="key"
                        header={t('main.permissao.state')}
                        body={(row) => t(row.acao.permissao?.state || row.key)}
                    />
                    <Column
                        header={t('main.grupopermissao.permitido')}
                        body={(row) => (
                            <ToggleButton
                                checked={row.acao.permitido}
                                disabled={row.acao.salvando}
                                onLabel={t('main.grupopermissao.permitido')}
                                offLabel={t('main.grupopermissao.bloqueado')}
                                onIcon="pi pi-check"
                                offIcon="pi pi-ban"
                                className={row.acao.permitido ? 'p-button-success' : 'p-button-danger'}
                                pt={{ icon: { style: { color: '#fff' } } }}
                                onChange={(e) => this.togglePermissao(row.acao.permissao, e.value)}
                            />
                        )}
                        style={{ width: '10rem' }}
                        bodyClassName="text-center"
                    />
                </DataTable>
            </Dialog>
            </>
        );
    }

    render() {
        const { parentId: grupoId, parentLabel, parentRota, parentIdentidade } = decodificarContextoRelacao(this.props.searchparams);
        // Leva o id do pai na volta (sem `acao`) pra EntityGrid restaurar a seleção do grupo.
        const goToParent = parentRota
            ? () => this.props.navigate({ pathname: parentRota, search: grupoId ? { id: grupoId } : {} })
            : undefined;

        const breadcrumbPai = [
            ...(parentIdentidade ? [{
                label: UtilService.traduzir(parentIdentidade + '.plural'),
                command: goToParent,
            }] : []),
            ...(parentLabel ? [{
                label: parentLabel,
                command: goToParent,
            }] : []),
        ];

        const filtroInicial = grupoId
            ? { grupo: { constraints: [{ value: grupoId, matchMode: 'equals' }] } }
            : undefined;

        return (
            <EntityGrid
                identidade="main.grupopermissao"
                icone="pi-shield"
                storageKey="dt-grupopermissao"
                model={MODEL_PADRAO}
                permissoes={this.props.permissoes}
                entidade={GrupoPermissao}
                formulario={(m, ctx) => <GrupoPermissaoFormulario model={m} contexto={ctx} />}
                configuracao={{}}
                navigate={this.props.navigate}
                location={this.props.location}
                searchparams={this.props.searchparams}
                breadcrumbPai={breadcrumbPai}
                onVoltar={goToParent}
                filtroInicial={filtroInicial}
                templateSimples={(header) => this.renderDataTable(header)}
                onAtualizarSimples={this.carregar}
                modoVisualizacaoInicial="simples"
                renderers={RENDERERS_PADRAO}
            />
        );
    }
}

export default withRouter(GrupoPermissionamentoPage);
